import { Swiper, SwiperSlide } from "swiper/react";

import { useGetDistributors } from "@/hooks/api/content.hooks";

import DistributorCard from "../cards/DistributorCard";

const MainDistributors = () => {
  const { data } = useGetDistributors();

  return (
    <div className="">
      <Swiper
        slidesPerView={3}
        spaceBetween={16}
        breakpoints={{
          300: {
            slidesPerView: 2,
          },

          500: {
            slidesPerView: 3,
          },
          1200: { spaceBetween: 12 },
          1400: { spaceBetween: 16 },
        }}
        className="overflow-visible"
      >
        {data.map((distributor) => (
          <SwiperSlide key={distributor.id}>
            <DistributorCard distributor={distributor} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MainDistributors;
